import { HttpClient, HttpContext } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GenericDataReadDataByIdRequestDTO, GenericListDataReadAllPaginatedRequestDTO, GenericListUICCreateRequestDTO, GenericListUICDeleteRequestDTO, GenericListUICDTO, GenericListUICList, GenericListUICReadAllPaginatedRequestDTO, GenericListUICReadAllRequestDTO, GenericListUICReadByTenantIdRequestDTO, GenericListUICReadByIdRequestDTO, GenericListUICReorderDisplaySeqRequestDTO, GenericListUICReorderDisplaySeqResponseDTO, GenericListUICUpdateRequestDTO, GenericListUICCloneRequestDTO, GenericListUICCloneResponseDTO, GenericListUICReadConfigByTenantIdRequestDTO, CommonCloneRequestDTO, CommonCloneResponseDTO } from "./list-uic.interface";
import { map, Observable } from "rxjs";
import { lowercaseFirstLetter, lowercaseFirstLetterKeys } from "src/app/Shared/customFunctions/CustomFunctions";
import { GenericListUIC_Create, GenericListUIC_Update, GenericListUIC_Delete, GenericListUIC_ReadById, GenericListUIC_ReadByTenantId, GenericListUIC_ReadAll, GenericListUIC_ReadAllPaginated, GenericListData_ReadAllPaginated, GenericListData_ReadDataById, GenericListUIC_ReorderDisplaySeq, GenericListUIC_Clone, GenericListUIC_ReadConfigByTenantId, GenericListUIC_CommonClone } from "src/app/GlobalVariables";
import { resolveTenantUrl, tenantOverrideOptions } from "src/app/Common/ApiConfigurationService/resolve-tenant-url.util";
import { UserLoginService } from "src/app/Common/UserLoginService/userlogin.service";


@Injectable({
    providedIn: 'root'
})
export class GenericListUicService {

    constructor(private http: HttpClient, private userLoginService: UserLoginService) { }




    // baseUrlOverride/companyId/branchId (all optional, GenericListUIC_* methods
    // only): GenericListUIC config does not live on the Identity Server
    // (confirmed live - routing this via apig.advin.in does not work), so
    // every operation - reads AND writes - needs to go directly to the
    // selected tenant's own gateway with that tenant's own
    // CompanyId/BranchId headers. Omitted for every other caller - behaves
    // exactly as before.
    GenericListUIC_Create(data: GenericListUICCreateRequestDTO, baseUrlOverride?: string, companyId?: string | number, branchId?: string | number): Observable<GenericListUICDTO> {
        return this.http.post<GenericListUICDTO>(resolveTenantUrl(GenericListUIC_Create, baseUrlOverride), data, tenantOverrideOptions(baseUrlOverride, companyId ?? 0, branchId ?? 0));
    }

    GenericListUIC_Update(data: GenericListUICUpdateRequestDTO, baseUrlOverride?: string, companyId?: string | number, branchId?: string | number): Observable<GenericListUICDTO> {
        return this.http.post<GenericListUICDTO>(resolveTenantUrl(GenericListUIC_Update, baseUrlOverride), data, tenantOverrideOptions(baseUrlOverride, companyId ?? 0, branchId ?? 0));
    }


    GenericListUIC_Delete(data: GenericListUICDeleteRequestDTO, baseUrlOverride?: string, companyId?: string | number, branchId?: string | number): Observable<void> {
        return this.http.post<void>(resolveTenantUrl(GenericListUIC_Delete, baseUrlOverride), data, tenantOverrideOptions(baseUrlOverride, companyId ?? 0, branchId ?? 0));
    }


    GenericListUIC_ReadById(data: GenericListUICReadByIdRequestDTO, baseUrlOverride?: string, companyId?: string | number, branchId?: string | number): Observable<GenericListUICDTO> {
        return this.http.post<GenericListUICDTO>(resolveTenantUrl(GenericListUIC_ReadById, baseUrlOverride), data, tenantOverrideOptions(baseUrlOverride, companyId ?? 0, branchId ?? 0));
    }


    GenericListUIC_ReadByTenantId(data: GenericListUICReadByTenantIdRequestDTO, baseUrlOverride?: string, companyId?: string | number, branchId?: string | number): Observable<GenericListUICList> {
        return this.http.post<GenericListUICList>(resolveTenantUrl(GenericListUIC_ReadByTenantId, baseUrlOverride), data, tenantOverrideOptions(baseUrlOverride, companyId ?? 0, branchId ?? 0))
            .pipe(
                map((res) => ({
                    ...res,
                    items: res.items.map(i => ({
                        ...i,
                        propertyName: lowercaseFirstLetter(i.propertyName)
                    }))
                }))
            );
    }

    GenericListUIC_ReadAll(data: GenericListUICReadAllRequestDTO, baseUrlOverride?: string, companyId?: string | number, branchId?: string | number): Observable<GenericListUICList> {
        return this.http.post<GenericListUICList>(resolveTenantUrl(GenericListUIC_ReadAll, baseUrlOverride), data, tenantOverrideOptions(baseUrlOverride, companyId ?? 0, branchId ?? 0));
    }

    GenericListUIC_ReadAllPaginated(data: GenericListUICReadAllPaginatedRequestDTO, baseUrlOverride?: string, companyId?: string | number, branchId?: string | number): Observable<GenericListUICList> {
        return this.http.post<GenericListUICList>(resolveTenantUrl(GenericListUIC_ReadAllPaginated, baseUrlOverride), data, tenantOverrideOptions(baseUrlOverride, companyId ?? 0, branchId ?? 0));
    }

    // baseUrlOverride (optional): the viewed tenant's own AM gateway origin,
    // e.g. CompanyDetailComponent.apiConfigOverride.AM (Print Template /
    // Label Detail tabs' row-data reads). Omitted for every other caller -
    // behaves exactly as before.
    GenericListData_ReadAllPaginated<T>(data: GenericListDataReadAllPaginatedRequestDTO, baseUrlOverride?: string, companyId?: string | number, branchId?: string | number): Observable<any[]> {
        const body = { ...data, actionUser: data.actionUser ?? this.userLoginService.User()?.userId?.toString() };
        return this.http.post<any[]>(resolveTenantUrl(GenericListData_ReadAllPaginated, baseUrlOverride), body, tenantOverrideOptions(baseUrlOverride, companyId ?? 0, branchId ?? 0)).pipe(
            map((res) => {
                return res.map(item => lowercaseFirstLetterKeys(item));
            })
        );
    }

    GenericData_ReadDataById(data: GenericDataReadDataByIdRequestDTO): Observable<object> {
        return this.http.post<object>(GenericListData_ReadDataById, data).pipe(
            map((res) => lowercaseFirstLetterKeys(res))
        );
    }

    GenericListUIC_ReorderDisplaySeq(data: GenericListUICReorderDisplaySeqRequestDTO, baseUrlOverride?: string, companyId?: string | number, branchId?: string | number): Observable<GenericListUICReorderDisplaySeqResponseDTO> {
        return this.http.post<GenericListUICReorderDisplaySeqResponseDTO>(resolveTenantUrl(GenericListUIC_ReorderDisplaySeq, baseUrlOverride), data, tenantOverrideOptions(baseUrlOverride, companyId ?? 0, branchId ?? 0));
    }

    GenericListUIC_Clone(data: GenericListUICCloneRequestDTO, baseUrlOverride?: string, companyId?: string | number, branchId?: string | number): Observable<GenericListUICCloneResponseDTO> {
        return this.http.post<GenericListUICCloneResponseDTO>(resolveTenantUrl(GenericListUIC_Clone, baseUrlOverride), data, tenantOverrideOptions(baseUrlOverride, companyId ?? 0, branchId ?? 0));
    }

    GenericListUIC_ReadConfigByTenantId(data: GenericListUICReadConfigByTenantIdRequestDTO, baseUrlOverride?: string, companyId?: string | number, branchId?: string | number): Observable<GenericListUICList> {
        return this.http.post<GenericListUICList>(resolveTenantUrl(GenericListUIC_ReadConfigByTenantId, baseUrlOverride), data, tenantOverrideOptions(baseUrlOverride, companyId ?? 0, branchId ?? 0))
            .pipe(
                map((res) => ({
                    ...res,
                    items: res.items.map(i => ({
                        ...i,
                        propertyName: lowercaseFirstLetter(i.propertyName)
                    }))
                }))
            );
    }

    CommonClone(data: CommonCloneRequestDTO): Observable<CommonCloneResponseDTO> {
        return this.http.post<CommonCloneResponseDTO>(GenericListUIC_CommonClone, data);
    }


}
